import Vue from "vue";
import Router from "vue-router";

const Home = () => import("@/pages/home/Home");
// 注册 登录 忘记密码 重置密码 确认密码
//手机注册页面
const Regist = () => import("@/pages/Regist");
//邮箱注册页面
const Registmail = () => import("@/pages/Registmail");
const Login = () => import("@/pages/Login/Login");
const forgetPassword = () => import("@/pages/Login/forgetPassword");
const resetPassword = () => import("@/pages/Login/resetPassword");
//忘记邮箱密码
const forgetPasswordMail = () => import("@/pages/Login/forgetPasswordMail");
const amendSuccess = () => import("@/pages/Login/amendSuccess");
// 单程订票页面
const BookingTicketOne = () => import("@/pages/bookingTicket/BookingTicketOne");
// 双程订票页面
const BookingTicketTwo = () => import("@/pages/bookingTicket/bookingTicketTwo");
// 单程订票选择后查看检查页面
const InspectOne = () => import("@/pages/bookingTicket/inspectOne");
// 多程订票选择后查看检查页面
const InspectTwo = () => import("@/pages/bookingTicket/inspectTwo");
// 预订页面
const AdvanceBooking = () => import("@/pages/bookingTicket/advanceBooking");
// 预定表格填写完成后跳转页面
const Accomplish = () => import("@/pages/bookingTicket/accomplish");
//付款中
const lnpayment = () => import("@/pages/bookingTicket/lnpayment");
//支付失败
const Failureofpayment = () => import("@/pages/bookingTicket/Failureofpayment");
// 我的行程頁面
const Schedule = () => import("@/pages/schedule/Schedule");
const MyTicket = () => import("@/pages/schedule/myTicket");
const Invoice = () => import("@/pages/schedule/invoice");
const PasswordManagement = () => import("@/pages/schedule/passwordManagement");
const PassengerManagement = () =>
  import("@/pages/schedule/passengerManagement");
const IntegralManagement = () => import("@/pages/schedule/integralManagement");
// 退款页面
const Details = () => import("@/pages/schedule/details");
// 保单详情页
const InsuranceDetail = () => import("@/pages/schedule/insuranceDetail");
// 退票页面
const ReturnTicket = () => import("@/pages/schedule/returnTicket");
// 改签页面
const AlterTickets = () => import("@/pages/schedule/alterTickets");
// 改签页面
const AlterTicketsto = () => import("@/pages/schedule/alterTicketsto");
// 报销单页面
const ExpenseAccount = () => import("@/pages/schedule/expenseAccount");
// 关于我们页面
const WebDescription = () => import("@/pages/webDescription/webDescription");
// 联系我们页面
const ContactUs = () => import("@/pages/contactUs");
// 消息页面
const News = () => import("@/pages/news/news");
const PersonalCenter = () => import("@/pages/PersonalCenter/PersonalCenter");
const CompanyProfile = () => import("@/pages/webDescription/companyProfile");

Vue.use(Router);

export default new Router({
  // mode: 'history',
  //mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      name: "home",
      path: "/",
      component: Home
    },
    {
      name: "regist",
      path: "/regist",
      component: Regist
    },
    {
      name: "registmail",
      path: "/registmail",
      component: Registmail
    },
    {
      name: "login",
      path: "/login",
      component: Login
    },
    {
      name: "forgetPassword",
      path: "/forgetPassword",
      component: forgetPassword
    },
    {
      name: "forgetPasswordMail",
      path: "/forgetPasswordMail",
      component: forgetPasswordMail
    },
    {
      name: "resetPassword",
      path: "/resetPassword",
      component: resetPassword
    },
    {
      name: "amendSuccess",
      path: "/amendSuccess",
      component: amendSuccess
    },
    {
      name: "bookingTicketOne",
      path: "/bookingTicketOne",
      component: BookingTicketOne
    },
    {
      name: "bookingTicketTwo",
      path: "/bookingTicketTwo",
      component: BookingTicketTwo
    },
    {
      name: "inspectOne",
      path: "/bookingTicket/inspectOne",
      component: InspectOne
    },
    {
      name: "inspectTwo",
      path: "/bookingTicket/inspectTwo",
      component: InspectTwo
    },
    {
      name: "advanceBooking",
      path: "/bookingTicket/advanceBooking",
      component: AdvanceBooking
    },
    {
      name: "accomplish",
      path: "/bookingTicket/advanceBooking/accomplish",
      component: Accomplish
    },
    {
      name: "lnpayment",
      path: "/bookingTicket/advanceBooking/lnpayment",
      component: lnpayment
    },
    {
      name: "Failureofpayment",
      path: "/bookingTicket/advanceBooking/Failureofpayment",
      component: Failureofpayment
    },
    {
      name: "schedule",
      path: "/schedule",
      component: Schedule,
      redirect: "/schedule/myTicket",
      children: [
        {
          name: "myTicket",
          path: "/schedule/myTicket",
          component: MyTicket
        },
        {
          name: "invoice",
          path: "/schedule/invoice",
          component: Invoice
        },
        {
          name: "passwordManagement",
          path: "/schedule/passwordManagement",
          component: PasswordManagement
        },
        {
          name: "passengerManagement",
          path: "/schedule/passengerManagement",
          component: PassengerManagement
        },
        {
          name: "integralManagement",
          path: "/schedule/integralManagement",
          component: IntegralManagement
        }
      ]
    },
    {
      name: "details",
      path: "/schedule/details",
      component: Details
    },
    {
      name: "insuranceDetail",
      path: "/schedule/insuranceDetail",
      component: InsuranceDetail
    },
    {
      name: "expenseAccount",
      path: "/schedule/details/expenseAccount",
      component: ExpenseAccount
    },
    {
      name: "returnTicket",
      path: "/schedule/returnTicket",
      component: ReturnTicket
    },
    {
      name: "alterTickets",
      path: "/schedule/alterTickets",
      component: AlterTickets
    },
    {
      name: "alterTicketsto",
      path: "/schedule/alterTicketsto",
      component: AlterTicketsto
    },
    {
      name: "webDescription",
      path: "/webDescription",
      component: WebDescription
    },
    {
      name: "PersonalCenter",
      path: "/PersonalCenter",
      component: PersonalCenter
    },
    {
      name: "contactUs",
      path: "/contactUs",
      component: ContactUs
    },
    {
      name: "news",
      path: "/news",
      component: News
    },
    {
      name: "companyProfile",
      path: "/companyProfile",
      component: CompanyProfile
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js